import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import UpgradeButton from 'components/Buythrough/UpgradeButton';
import helperMarkdownToComponent from 'helpers/Data';
import {
  redirectToExternalUrl,
  helperGetAccountUrl,
  setPathForReEntryRedirect,
} from 'helpers/RouteHelper';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';

const Message = ({
  account,
  header: messageHeader,
  isTrailerUpsell,
  messageText: body,
  pathOverride,
  subscriptionPaused,
  theme,
}) => {
  const {
    playback_upsellBlockSignIn: signInMarkdown,
    upsellTrailer_header: trailerHeaderText,
    upsellTrailer_message: trailerMessageText,
  } = window.Language;
  let header = messageHeader;
  let messageText = body;

  if (isTrailerUpsell) {
    header = trailerHeaderText;
    messageText = trailerMessageText;
  }

  const signInLink = data => {
    const { children, href } = data;
    const onClick = () => {
      setPathForReEntryRedirect(pathOverride);
    };
    return (
      <a href={href} onClick={onClick}>
        {children}
      </a>
    );
  };

  const signInText = helperMarkdownToComponent(signInMarkdown, null, {
    // eslint-disable-next-line react/prop-types
    Paragraph: ({ children }) => {
      if (!children) return null;
      return <p className={theme.signInText}>{children}</p>;
    },
    Link: signInLink,
  });

  const onSignUpClick = isJoinNow => {
    setPathForReEntryRedirect(pathOverride);
    const { blackFridaySignUpUrl, externalSignUpUrl } = window.ExternalConfig;
    const url = isJoinNow ? blackFridaySignUpUrl : externalSignUpUrl;
    if (url) return redirectToExternalUrl(url);
    return null;
  };

  const signInButton =
    account || isTrailerUpsell ? null : <div className={theme.signInContainer}>{signInText}</div>;
  const upgradeButton = (
    <UpgradeButton
      isResumeButton={subscriptionPaused}
      theme={theme}
      onClick={({ isJoinNow }) => {
        handleAnalytics({
          event: Events.UPGRADE_NOW_BUTTON_CLICKED,
          payload: {
            page_item_title: header,
            page_action_location: 'upsell',
          },
        });
        if (subscriptionPaused) {
          redirectToExternalUrl(helperGetAccountUrl());
        } else {
          onSignUpClick(isJoinNow);
        }
      }}
    />
  );

  const trailerBackgroundImage = _.get(window.ExternalConfig, 'upsellPromo.trailerBackgroundImage');
  const desktopBackground = {
    background: `url('${trailerBackgroundImage}') center center/cover no-repeat`,
  };
  return (
    <div
      className={classNames([theme.messageContainer, isTrailerUpsell && theme.trailerContainer])}
      style={desktopBackground}
    >
      <div className={theme.containerLeft}>
        <div className={theme.title}>{header}</div>
        <div className={theme.message}>{messageText}</div>
      </div>

      <div className={theme.containerRight}>
        <div className={theme.button}>{upgradeButton}</div>
        {!subscriptionPaused ? signInButton : null}
      </div>
    </div>
  );
};

Message.defaultProps = {
  account: null,
  header: '',
  isTrailerUpsell: false,
  messageText: '',
  pathOverride: null,
  subscriptionPaused: false,
};

Message.propTypes = {
  account: PropTypes.shape({}),
  header: PropTypes.string,
  isTrailerUpsell: PropTypes.bool,
  messageText: PropTypes.string,
  pathOverride: PropTypes.string,
  subscriptionPaused: PropTypes.bool,
  theme: PropTypes.shape({}).isRequired,
};

export default Message;
